// import Router from '../routes/routes';
import routes from "../routes/routes";
import router from "../routes/router";
import { newApplication } from "@/schema.js";
import LoginDialog from "@/components/Dialogs/LoginDialog";
import { reset_keys_on_events } from "@/store/store.js";
import moment from "moment";
import Pusher from 'pusher-js';
import axios from "axios";

/**
 * fetch_application_owners - Retrieve all owners attached to a application.
 * @param {vuex} context
 * @param {string} application_id
 */
async function fetch_application_referrer(context, application_id) {
    let response = await axios.get(`/api/v1/application/${application_id}/get_existing_owners`);
    context.commit("application_referrer", response.data);
}

async function reset_state(context){
    context.commit('reset_state');
}

async function reset_state_on_application_load(context){
    context.commit('reset_state', reset_keys_on_events.on_application_load);
}

async function reset_state_on_application_save(context){
    context.commit('reset_state', reset_keys_on_events.on_application_save);
}

async function load_blank_application(context){

    reset_state_on_application_load(context);
    context.commit('setApplicationStatus', {
        id: null,
        loading: false,
        dirty: false,
        loaded: true,
    });

    let application = newApplication();

    application.permissions["view-metadata"] = false;
    application.permissions["view"] = false;
    application.permissions["update"] = true;
    application.permissions["delete"] = false;
    application.permissions["transfer"] = false;
    application.permissions["archive"] = false;
    application.permissions["un-archive"] = false;
    application.permissions["view-assessment"] = false;

    context.commit('set_selected_application', application);
}

async function get_audit_log(context, application_id){
    try{
        let { data: auditLogs } = await axios.get(`/api/v1/audit/logs/${application_id}`);
        context.commit('set_audit_logs', auditLogs);
        return auditLogs;
    }catch(error){
        console.error('Failed to get audit logs');
        console.error(error);
    }
    return false;
}

async function get_email_audit_logs(context, application_id){
  try{
      let { data: emailAuditLogs } = await axios.get(`/api/v1/audit/emailLogs/${application_id}`);
      context.commit('set_email_logs', emailAuditLogs);
      return emailAuditLogs;
  }catch(error){
      console.error('Failed to get email audit logs');
      console.error(error);
  }
  return false;
}

async function get_sms_audit_logs(context, application_id){
  try{
      let { data: smsAuditLogs } = await axios.get(`/api/v1/audit/smsLogs/${application_id}`);
      context.commit('set_sms_logs', smsAuditLogs);
      return smsAuditLogs;
  }catch(error){
      console.error('Failed to get SMS audit logs');
      console.error(error);
  }
  return false;
}

async function get_call_outcome_logs(context, loan_application_id){
  try{
    let { data: logs } = await axios.get(`/api/v1/audit/callOutcomeLogs/${loan_application_id}`);
    context.commit('set_call_outcome_logs', logs);
    return logs;
  }catch(error){
    console.error('Failed to get call outcome logs');
    console.error(error);
  }
  return false;
}

async function add_audit_log (context, payload) {
  try{
      let { data } = await axios.post(`/api/v1/audit/${payload.application_id}`, {
        message :  payload.message
      });

      return data;
  }catch(error){
      console.error('Failed to store audit logs');
      console.error(error);
  }
  return false;
}

async function ensure_audit_logs(context, payload){
    if(! context.getters.auditLogs || payload.force){
        return await get_audit_log(context, payload.id);
    }
    return context.getters.auditLogs;
}


function setMenuFromPermission(application){

    // update side menu and enable/disable the pages available
    routes.applicationPages.props.menu[2].disabled = ! application || ! application.permissions.update;
    routes.applicationPages.props.menu[3].disabled = ! application || ! application.permissions.view;
    routes.applicationPages.props.menu[4].disabled = ! application || ! application.permissions['view-assessment'];
    routes.applicationPages.props.menu[5].disabled = ! application || ! application.permissions.view;
    routes.applicationPages.props.menu[6].disabled = ! application || ! application.permissions['process-settlement'];
    routes.applicationPages.props.menu[7].disabled = ! application || ! application.permissions.view;
}

async function load_application(context, application_id){

    reset_state_on_application_load(context);
    context.commit('setApplicationStatus', {
        id: application_id,
        loading: true,
        loaded: false,
        dirty: false,
    });

    try{
        let { data: application } = await axios.get(`/api/v1/application/${application_id}`);
        context.commit('set_selected_application', application);

        setMenuFromPermission(application);

        context.commit('setApplicationStatus', {
            loading: false,
            loaded: true,
        });

        fetch_application_referrer(context, application_id)
        return true;

    }catch(error){
      console.error('Application request failed');
      console.error(error);
    }

    context.commit('setApplicationStatus', {
        loading: false,
    });

    return false;
}

async function reload_application(context){
    let status = context.getters.application_status;

    if(status.id == null){
        return; // cannot reload an unsaved application
    }else{
        if(status.dirty){
            console.warn('Unable to reload application, there are unsaved changes.');
        }else{
            reset_state_on_application_save(context);
            context.commit('setApplicationStatus', {
                loading: true,
                dirty: false,
            });

            try{
                let { data: application } = await axios.get(`/api/v1/application/${status.id}`);
                context.commit('set_selected_application', application);

                setMenuFromPermission(application);

                context.commit('setApplicationStatus', {
                    loading: false,
                    loaded: true,
                });

                fetch_application_referrer(context, status.id)
                return true;

            }catch(error){
              console.error('Application request failed');
              console.error(error);
            }

            context.commit('setApplicationStatus', {
                loading: false,
            });

            return false;
        }
    }
}

async function ensure_application(context, application_id){
    if(application_id == null){
        return false;
    }

    if(application_id != context.getters.application_status.id){
        if(application_id == 'new'){
            return await context.dispatch('load_blank_application');
        }else{
            return await context.dispatch('load_application', application_id);
        }
    }
}

async function update_application(context, application_data){
    context.commit('set_selected_application', application_data);

    return true;
}

async function save_application(context, application_data){

    reset_state_on_application_save(context);
    context.commit('setApplicationStatus', {
        loading: true,
    });
    context.commit('set_updating_application', true);

    try{
        let { data: application } = await axios.post(`/api/v1/application`, application_data);
        // when create a new application, the application_id is null.
        // we need to set selected application when first time we save it.
        if (!!!context.getters.application_id) {
          context.commit('set_selected_application', application);
        }
        context.commit('set_investment_property_in_liability', application);
        context.commit('setApplicationStatus', {
            loading: false,
            dirty: false,
        });
        context.commit('set_updating_application', false);

        return true;

    } catch(error) {
        console.error('save_application() request failed');
        console.error(error);

        if(error.response.status == 419){
            window.vue.$modal.show(LoginDialog);
        }

        context.commit('setApplicationStatus', {
            loading: false,
        });

        throw error;
    }
}

async function saveBrokerIncomes(context, payload) {
  try {
    const response = await axios.post(`/api/v1/application/saveBrokerIncomes`, payload);
    return response;
  } catch (error) {
    console.error(error)
  }
}

async function request_veda_for_application(context, {
  application_data,
  applicant_index,
  resubmit = false,
  oneScoreReport = false,
  alternative = false,
  bothComprehensiveAndOneScore = false}
) {

  reset_state_on_application_save(context);

  try {

    await save_application(context, application_data);
    context.commit('setApplicationStatus', {
      loading: true,
    });

    let applicant = context.getters.application.applicants[applicant_index];

    // get applicant by index, get id, make request, load response
    // NOTE resubmit params refer to whether credit report is to be generated again.
    // NOTE resubmit params is boolean, default value is false
    let {
      data: result
    } = await axios.get(`/api/v1/applicant/${applicant.id}/request_veda`, {
      params: {
        resubmit,
        oneScoreReport,
        alternative,
        bothComprehensiveAndOneScore
      }
    });
    let application = result['application'];
    //TODO: remove this once signed off
    // if (result['success']) {
    //   application.applicants[0] = addressFromVeda(application.applicants[0]);
    // }
    context.commit('set_selected_application', application);
    context.commit('setApplicationStatus', {
      loading: false,
      dirty: false,
    });
    return result;
  } catch (error) {
    console.error(error);

    if (error.response.status == 419) {
      window.vue.$modal.show(LoginDialog);
    }
    context.commit('setApplicationStatus', {
      loading: false,
    });

    throw error;
  }
}

async function backfill_voi(context, {applicant_id}) {
    let result = await axios.post(`/api/v1/applicant/${applicant_id}/backfill_voi`);
    if (result.data.application) {
      let application = result.data.application;
      context.commit('set_selected_application', application);
      context.commit('setApplicationStatus', {
        loading: false,
        dirty: false,
      });
    }
    else {
      return false;
    }
}

async function request_voi_for_application(context, {application_data, applicant_id}) {
 reset_state_on_application_save(context);
  try {
    await save_application(context, application_data);
    context.commit('setApplicationStatus', {
      loading: true,
    });

    let {
      data: result
    } = await axios.post(`/api/v1/applicant/${applicant_id}/request_voi`);
    context.commit('setApplicationStatus', {
      loading: false,
      dirty: false,
    });
    return result;
  } catch (error) {
    console.error('request_voi_for_application request failed');
    console.error(error);
    if (error.response.status == 419) {
      window.vue.$modal.show(LoginDialog);
    }
    context.commit('setApplicationStatus', {
      loading: false,
    });

    throw error;
  }
}

/**
 * this function returns address from veda report for the applicant
 * @param applicant
 * @returns {{veda_report}|*}
 */
function  addressFromVeda(applicant){
  if (applicant.veda_report && applicant.veda_report.user_details) {
    applicant.veda_report.user_details.address.forEach(function (address){
      let match = false;
      applicant.addresses.previous.forEach(function (previousAddress){
        if(address.address.full_address == previousAddress.address.full_address){
          //if there is already matching full address then we dont need to add it in the previous address array
          match = true;
        }
      });
      if(!match){
        //add the address to front of the previous address
        applicant.addresses.previous.unshift(address);
      }
    });
  }
  return applicant;
}

async function submit_application_via_method(context, application_data, method){

    reset_state_on_application_save(context);
    try {
        if (Object.keys(application_data).length > 0 && method == 'email'){
          const postData = (application_data.document_ids) ? { documentId : application_data.document_ids } : {};
          let { data: response } = await axios.post(`/api/v1/application/${application_data.application_id}/submit/${method}`, postData);
          if (response.fullApplication) {
            context.commit('set_selected_application', response.fullApplication);
          }
          return response;
        } else {
          let { data: response } = await axios.post(`/api/v1/application/${application_data.loan.id}/submit/${method}`, application_data.custom_params);
          if (response.fullApplication) {
            context.commit('set_selected_application', response.fullApplication);
          }
          return response;
        }
    } catch (error){
        console.error('submit_application() request failed');
        console.error(error);
        throw error;
    }
}

async function submit_application_via_api(context, application_data){
    return await submit_application_via_method(context, application_data, 'api');
}

async function submit_application_via_email(context, application_data){
    return await submit_application_via_method(context, application_data, 'email');
}

async function submit_application_via_url(context, application_data){
    return await submit_application_via_method(context, application_data, 'url');
}

async function submit_for_application_readinessCheck(context, application_data) {
  try {
    let { data: response } = await axios.post(
      `/api/v1/application/readiness_check/${application_data.loan.id}`
    );
    return response;
  } catch (error) {
    throw error;
  }
}

async function submit_application(context, application_data){

    reset_state_on_application_save(context);
    try{
        const postData = (application_data.uploadedDocument) ? { documentId : application_data.uploadedDocument } : {};
        let {data: response} = await axios.post(`/api/v1/application/${application_data.loan.id}/submit`, postData);
        return response;

    }catch(error){
        console.error('submit_application() request failed');
        console.error(error);

        if(error.response.status == 419){
            window.vue.$modal.show(LoginDialog);
        }

        return error.response.data;
    }
}

async function submit_for_compliance(context, application_data){

    try{
        let response = await axios.post(`/api/v1/application/submit_for_compliance`, application_data);
        return response.data;
    }catch(error){
        console.error(error);
        if(error.response.status == 419){
            window.vue.$modal.show(LoginDialog);
        }
        return error.response.data;
    }

}

async function get_existing_settlement(context, application_id){
    try {
        let response = await axios.get(`/api/v1/application/${application_id}/settlement`);
        return response.data;
    } catch(error){
        console.error(error);
        if(error.response.status == 419){
            window.vue.$modal.show(LoginDialog);
        }
        return false;
    }

}

async function save_settlement_request(context, settlement_data){
    try{
        let application_id = settlement_data['loan_application_id'];
        let settlement_id = settlement_data['settlement_id'];
        let response = await axios.post(`/api/v1/application/${application_id}/settlement/${settlement_id}`, settlement_data);
        return true;

    }catch(error){
        console.error('save_settlement_request() request failed');
        console.error(error);

        if(error.response.status == 419){
            window.vue.$modal.show(LoginDialog);
        }

        return error.response.data;
    }

}

async function fetch_work_basket(context) {
  try {
      const filters = {
        ...context.state.advance_search_application,
        ...context.state.pagination
      };

      let response = await axios.post('/api/v1/application/basket', { filters });

      if (context.state.pagination.backend_pagination) {
        context.commit('set_work_basket', response.data.original.results);
        context.commit('set_pagination', response.data.original.pagination);
      } else {
        context.commit('set_work_basket', response.data);
      }
      return true;
  } catch (error) {
      console.error('Basket request failed');
      console.error(error);
  }

  return false;
}

async function refresh_work_basket(context) {
  await context.dispatch('fetch_work_basket');
}

async function fetch_live_auction_previews(context) {
  try {
    let response = await axios.get('/api/v1/auction/live-previews');
    response.data.forEach(item => {
      if (item.expires_at) {
        const expiredTime = new Date(item.expires_at);
        const convertedTime = new Date(expiredTime.getTime() + (-expiredTime.getTimezoneOffset()) * 60 * 1000);
        item['expired_time'] = convertedTime.getTime();
      } else {
        item['expired_time'] = 0;
      }
    })
    context.commit('set_live_auction_previews', response.data);
    return {
      'success': true,
      'data': '',
    };
  } catch (err) {
    console.error('Failed to load live auction previews:', err);
    return {
      'success': false,
      'data': err.response.data,
    };
  }
}

async function fetch_auction_basket(context) {
  try {
    let response = await axios.get('/api/v1/auction/basket');
    response.data.applications.forEach(item => {
      const expiredTime = (new Date(item.expires_at)) ?? 0;
      //Convert the time due 10 hours time different in database
      const convertedTime = new Date(expiredTime.getTime() + (-expiredTime.getTimezoneOffset()) * 60 * 1000);
      item['expired_time'] = item.expires_at ? convertedTime.getTime() : 0;

    })
    context.commit('set_auction_basket', response.data);
    return {
      'success': true,
      'data': '',
    };
  } catch (err) {
    console.error('Basket request failed');
    return {
      'success': false,
      'data': err.response.data,
    };
  }
}

async function fetch_mql_auction_basket(context) {
  try {
    let response = await axios.get('/api/v1/mqlAuction/basket');
    response.data.applications.forEach(item => {
      const expiredTime = (new Date(item.expires_at)) ?? 0;
      const createdTime = new Date(item.loan_application_created_at);
      const currentTime = new Date();
      const differenceInMilliseconds = currentTime.getTime() - createdTime.getTime();
      const differenceInDays = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));

      //Convert the time due 10 hours time different in database
      const convertedTime = new Date(expiredTime.getTime() + (-expiredTime.getTimezoneOffset()) * 60 * 1000);

      item['age_of_lead'] = differenceInDays;
      item['expired_time'] = item.expires_at ? convertedTime.getTime() : 0;
    })
    context.commit('set_mql_auction_basket', response.data);
    return {
      'success': true,
      'data': '',
    };
  } catch (err) {
    console.error('Basket request failed');
    return {
      'success': false,
      'data': err.response.data,
    };
  }
}

async function fetch_distribution_auction(context) {
  try {
    let response = await axios.get('/api/v1/distribution/basket');
    context.commit('set_distribution_basket', response.data);
    return {
      'success': true,
      'data': '',
    };
  } catch (err) {
    console.error('Basket request failed');
    return {
      'success': false,
      'data': err.response.data,
    };
  }
}

async function fetch_auction_leads(context) {
  try {
    let response = await axios.get('/api/v1/auction/leads');
    context.commit('set_auction_lead_basket', response.data);
    return {
      'success': true,
      'data': '',
    };
  } catch (err) {
    console.error('Lead request failed');
    return {
      'success': false,
      'data': err.response.data,
    };
  }
}

async function submit_bid(context, payload) {
  try {
    const response = await axios.post('/api/v1/auction/submitBid', payload);
    return {
      title: "Bid Placed!",
      message: response.data.message ?? "Bid has been placed successfully.",
      link: response.data.link ?? null,
      status: 200
    };
  } catch (err) {
    console.log(err.response.data);
    return {
      title: "Bid Failed!",
      message: err.response.data
    }
  }
}

async function buy_auction(context, payload) {
  try {
    const response = await axios.post('/api/v1/auction/buy', payload);
    return {
      title: "Lead Purchase!",
      message: response.data.message ?? "Lead has been purchased successfully.",
      link: response.data.link ?? null,
      status: 200
    };
  } catch (err) {
    console.log(err.response.data);
    return {
      title: "Purchased Failed!",
      message: err.response.data
    }
  }
}

async function submit_lead_allocation(context, payload) {
  try {
    const response = await axios.post('/api/v1/auction/submitLeadAllocation', payload);
    return {
      title: "Lead Allocated!",
      message: response.data.message ?? "Lead has been allocated successfully.",
      link: response.data.link ?? null,
      status: 200
    };
  } catch (err) {
    console.log(err.response.data);
    return {
      title: "Allocated Failed!",
      message: err.response.data
    }
  }
}

async function process_the_auction(context, payload) {
  try {
    await axios.post('/api/v1/auction/process_the_auction', payload);
    return {
      title: "Successfully",
      message: "Process the auction successfully.",
      status: 200
    };
  } catch (err) {
    console.log(err.response.data);
    return {
      title: "Process Failed!",
      message: err.response.data
    }
  }
}

async function remove_from_auction(context, payload) {
  try {
    await axios.post('/api/v1/auction/remove_from_auction', payload);
    return {
      title: "Successfully",
      message: "Remove the auction successfully.",
      status: 200
    };
  } catch (err) {
    console.log(err.response.data);
    return {
      title: "Remove Auction Failed!",
      message: err.response.data
    }
  }
}

async function move_to_sql(context, payload) {
  try {
    await axios.post('/api/v1/auction/move_to_sql', payload);
    return {
      title: "Successfully",
      message: "Move to SQL Auction successfully.",
      status: 200
    };
  } catch (err) {
    console.log(err.response.data);
    return {
      title: "Process Failed!",
      message: err.response.data
    }
  }
}

async function fetch_highest_bid(context, payload) {
  try {
    let response = await axios.get('/api/v1/auction/getHighestBid', { params : payload });
    context.commit('set_current_auction', response.data);
  } catch (err) {
    console.log("Fetch bid Failed");
    console.log(err);
    return false;
  }
}

async function ensure_work_basket(context){
    if(! context.getters.work_basket){
        return await fetch_work_basket(context);
    }
    return true;
}

async function fetch_lender_list(context, force = false) {
  if (!context.getters.lenders_breakdown || force) {
    try {
      let response = await axios.get('/api/v1/administration/lenders_breakdown');
      context.commit('set_administration_lenders_breakdown', response.data);
      return response.data;
    } catch (e) {
      console.error(e);
    }
  }
  return context.getters.lenders_breakdown;
}

async function fetch_all_lead_requests(context) {
  try {
    let response = await axios.get('/api/v1/lead-requests');
    context.commit('set_lead_requests', response.data);
    return response.data;
  } catch (e) {
    console.error(e);
  }
}

async function fetch_lead_requests_by_pod(context, podId) {
  try {
    const response = await axios.get(`/api/v1/lead-requests-by-pod/${podId}`);
    context.commit('set_lead_requests', response.data);
    return response.data;
  } catch (e) {
    console.error(e);
  }
}

async function fetch_lead_requests_by_broker(context, brokerId) {
  try {
    const response = await axios.get(`/api/v1/lead-requests-by-broker/${brokerId}`);
    context.commit('set_lead_requests', response.data);
    return response.data;
  } catch (e) {
    console.error(e);
  }
}

async function save_lead_request(_, payload) {
  try {
    const response = await axios.post('/api/v1/lead-requests', payload);
    if (response.status === 200) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: 'Failed to save the number of leads. Please try again.' };
    }
  } catch (error) {
    console.error('Error saving leads number:', error);
    return { success: false, message: 'An error occurred while saving the number of leads.' };
  }
}

async function fetch_lead_requests_by_user(context, payload) {
  try {
    let response = await axios.get('/api/v1/lead-requests/forecasts');

    if(response.data.status == "success") {
      context.commit('set_lead_requests_forecasts', true);
    } else {
      context.commit('set_lead_requests_forecasts', false);
    }

    return response.data;
  } catch (e) {
    console.error(e);
  }
}

async function fetch_document_type_list(context, force = false) {
    try {
      let response = await axios.get('/api/v1/administration/fetch_document_type_list');
      return response.data;
    } catch (e) {
      console.error(e);
    }
}

async function perform_application_search(context, { key, query }){

    try{
        let response = await axios.post('/api/v1/application/search', { key, query });

        context.commit('set_application_search', {
            key,
            query,
            results: response.data,
        });

        return true;

    }catch(error){
        console.log(error);
        return false;
    }

}

const isOptionsEmpty = (options) => {
  if (Array.isArray(options)) {
    return options.length === 0;
  } else if (typeof options === 'object' && options != null) {
    return Object.keys(options).length === 0;
  }
  return false;
}

async function fetch_types(context, { params = {} } = {}){
  // check before fetch
  const types = [];
  try {
    params.types.forEach( type => {
      let options = context.state.types.options[type];
      if (options == null) {
        options = context.state.types.properties[type];
      }

      if (isOptionsEmpty(options)) {
        types.push(type);
      }
    })

    if (types.length === 0) {
      return true;
    }
    const response = await axios.post('/api/v1/zink/types', { types });
    context.commit('set_types', { data: response.data });
    return true;
  } catch(error) {
    console.error('Error fetching types:', error.response.data.error);
    return false;
  }
}

function invalidate_types(context){
    context.state.types = null;
}

/**
 * load templates from doc_templates
 *
 * @param context
 * @returns {Promise<boolean>}
 */
async function fetch_doc_templates(context) {
    try {
        let doc_templates = {};
        const response = await axios.get('/api/v1/templates');
        if (response.status === 200) {
            doc_templates = response.data;
        }
        context.commit('fetch_doc_templates', doc_templates);
        return true;
    } catch (error) {
        console.error('templates request failed');
        console.error(error);
    }
    return false;
}

async function fetch_doc_uploaded(context, params){
    try{
      let doc_uploaded = null;
        const response = await axios.post(`/api/v1/application/${params.application_id}/documents_uploaded`, params);

        if (response.data) {
          doc_uploaded = response.data;
        }
      context.commit('set_uploaded_documents', doc_uploaded);
        return response
    }catch(e){
        console.log(e)
    }
}

/**
 * load templates from doc_templates
 *
 * @param context
 * @returns {Promise<boolean>}
 */
async function store_doc_template(context, payload) {
    try {
        const config = {
            headers: {'content-type': 'multipart/form-data'}
        }

        const formData = new FormData();
        formData.append('file', payload.file);
        formData.append('display_name', payload.display_name);
        formData.append('description', payload.description);
        formData.append('template_type_id', payload.template_type_id);

        let doc_templates = {};
        let response = await axios.post('/api/v1/template/upload', formData, config);
        if (response.status === 200) {
            await fetch_doc_templates(context);
        }
        return true;
    } catch (error) {
        console.error('templates request failed');
        console.error(error);
    }
    return false;
}

/**
 * load data from csv
 *
 * @param context
 * @returns {Promise<boolean>}
 */
async function store_csv_glass_prices(context, payload) {
    try {
        const config = {
            headers: {'content-type': 'multipart/form-data'}
        }

        const formData = new FormData();
        formData.append('file', payload.file);
        formData.append('u12', payload.u12);

        let response = await axios.post('/api/v1/csv_import_glass_prices', formData, config);
        return response;
    } catch (error) {
        var response = {};
        response['status'] = error.response.status;
        response['message'] = error.response.data;
        return response;
    }
}

/**
 * get application_document_types from document_types table
 *
 * @param context
 * @returns {Promise<boolean>}
 */
async function fetch_document_types(context, payload) {
    try {
        let document_types = {};
        // /api/v1/get-applicant-document-types -> [DocumentController::class, 'getApplicantDocumentTypes']
        const response = await axios.get('/api/v1/get-applicant-document-types', {params: payload});

        if (response.data) {
            document_types = response.data;
        }
        context.commit('fetch_document_types', document_types);
        return true;
    } catch (error) {
        console.error('document types request failed');
        console.error(error);
    }
    return false;
}

/**
 * load document_requests from document_requests table
 *
 * @param context
 * @param payload
 * @returns {Promise<boolean>}
 */
async function fetch_document_requests(context, payload) {
    try {
        let document_requests = {};
        const response = await axios.get('/api/v1/get-document-requests', {params: payload});
        if (response.data) {
            document_requests = response.data;
        }
        context.commit('fetch_document_requests', document_requests);
        return true;
    } catch (error) {
        console.log('catched');
        console.error('document requests request failed');
        console.error(error);
    }
    return false;
}

/**
 * update the list document type on document_type table
 *
 * @param context
 * @param payload
 * @returns {Promise<boolean>}
 */
async function store_request_document_type(context, payload) {
    try {
        let document_requests = {};
        const response = await axios.post('/api/v1/update-document-type-and-request', payload);

        if (response.data) {
            document_requests = response.data;
        }
        context.commit('fetch_document_requests', document_requests);
        return true;
    } catch (error) {
        console.error('document requests request failed');
        console.error(error);
    }
    return false;
}

/**
 * update the list document type on document_type table
 *
 * @param context
 * @param payload
 * @returns {Promise<boolean>}
 */
async function send_email_document_types(context, payload) {
    try {
        let document_requests = {};

        const response = await axios.post('/api/v1/send-client-upload-documents-email', payload);

        return true;
    } catch (error) {
        console.error('document requests request failed');
        console.error(error);
    }
    return false;
}

/**
 * store upload a document and store the data to document request table
 *
 * @param context
 * @param payload
 * @returns {Promise<boolean>}
 */
async function store_document_requests(context, payload) {
    try {
        const config = {
            headers: {'content-type': 'multipart/form-data'}
        }

        const formData = new FormData();
        formData.append('file', payload.file);
        formData.append('application_id', payload.application_id);
        formData.append('applicant_id', payload.applicant_id);
        formData.append('document_type_id', payload.document_type_id);

        const response = await axios.post('/api/v1/store-a-document-request', formData, config);
        if (response.status == 200) {
            await fetch_document_requests(context, payload);
        }
        return true;
    } catch (error) {
        console.error('document requests request failed');
        console.error(error);
    }
    return false;
}

/**
 * remove a file from the document request
 *
 * @param context
 * @param payload
 * @returns {Promise<boolean>}
 */
async function remove_one_document_request(context, payload) {
    try {
        const config = {
            headers: {'content-type': 'multipart/form-data'}
        }

        const formData = new FormData();
        formData.append('document_request_id', payload.document_request_id);
        formData.append('document_id', payload.document_id);

        const response = await axios.post('/api/v1/remove-document-request', formData, config);
        if (response.status == 200) {
            await fetch_document_requests(context, payload);
        }
        return true;
    } catch (error) {
        console.error('failed to remove a file');
        console.error(error);
    }
    return false;
}

async function fetch_administration_roles(context, force=false) {

    if(
        force ||
        !context.getters.administration_permissions ||
        !context.getters.administration_roles
    ){

        try{
            let response = await axios.get('/api/v1/administration/roles');
            context.commit('set_administration_permissions', response.data.permissions);
            context.commit('set_administration_roles', response.data.roles);
            return true;

        }catch(error){
            console.error('Roles request failed');
            console.error(error);
            return false;
        }

    }else{
        return true;
    }
}

async function store_administration_roles(context, payload) {

    try{
        let response = await axios.post('/api/v1/administration/roles', payload);
        // context.commit('set_administration_permissions', response.data.permissions);
        context.commit('set_administration_roles', payload);
        return true;

    }catch(error){
      console.error('Roles request failed');
      console.error(error);
    }

    return false;
}

async function fetch_administration_users(context, force=false) {
    if (force || !context.state.administration_users) {
        try{
            let response = await axios.get('/api/v1/administration/users');
            context.commit('set_administration_users', response.data);
        }catch(error){
            console.error('Users request failed');
            console.error(error);
            return false;
        }
    }
    return true;
}

async function fetch_administration_user_pods(context, force=false) {
    if (force || !context.state.administration_pods) {
        try{
            let response = await axios.get('/api/v1/administration/user_pods');
            context.commit('set_administration_pods', response.data);
        }catch(error){
            console.error('Users request failed');
            console.error(error);
            return false;
        }
    }
    return true;
}


async function fetch_administration_loan_asset_types(context, force=false) {
  if (force || !context.state.administration_loan_asset_types) {
      try{
          let response = await axios.get('/api/v1/application/getAllLoanAssetTypes');
          context.commit('set_administration_loan_asset_types', response.data);
      }catch(error){
          console.error('request failed');
          console.error(error);
          return false;
      }
  }
  return true;
}

async function fetch_administration_app_status_types(context, force=false) {
  if (force || !context.state.administration_app_status_types) {
      try{
          let response = await axios.get('/api/v1/application/getAllAppStatusType');
          context.commit('set_administration_app_status_types', response.data);
      }catch(error){
          console.error('request failed');
          console.error(error);
          return false;
      }
  }
  return true;
}
/**
 * function to hide and show menu items
 * @param user
 */
function showHideSideMenu(user) {
  //hide show menu item
  routes.applicationPages.props.menu[10].visible = user.permissions.includes('access administration-page');
}

/**
 * Checks if the agent has visibility subscription and updates the menu visibility accordingly.
 * @param {boolean} hasVisibilitySubscription - Boolean indicating whether the agent has visibility subscription.
 */
function update_menu_visibility(hasVisibilitySubscription) {
  // Check if the agent has visibility subscription, and hide the "Deal Incomes" menu item if true
  if (hasVisibilitySubscription) {
    routes.applicationPages.props.menu.forEach((menuItem) => {
      if (menuItem.path === 'deal_income' || menuItem.path === 'dashboard') {
        menuItem.visible = false;
      }
    });
  } else {
    routes.applicationPages.props.menu.forEach((menuItem) => {
      if (menuItem.path === 'deal_income' || menuItem.path === 'dashboard') {
        menuItem.visible = true;
      }
    });
  }
}

/**
 * Checks the agent visibility subscription and commits the result to the store.
 * @param {Object} user - User object containing user details.
 * @param {Object} context - Vuex store context for committing changes.
 */
async function check_agent_subscription(user, context) {
  const primary_roles = user?.primary_roles || [];
  const isAgent = primary_roles.includes("Agent") || primary_roles.includes("Dealer Agent") || primary_roles.includes("Ausloans Agent");
  if (isAgent) {
    try {
      const response = await axios.get(`/api/v1/zink_all_services`);
      const agentVisibilitySubscribed = response.data.some(item => {
        return item.name === "Agent Visibility" && item.subscribed === true;
      });
      update_menu_visibility(agentVisibilitySubscribed);
      context.commit('set_agent_has_visibility_subscription', agentVisibilitySubscribed);
    } catch (error) {
      console.error('Error fetching agent visibility subscription:', error);
      context.commit('set_agent_has_visibility_subscription', false);
    }
  } else {
    update_menu_visibility(false);
    context.commit('set_agent_has_visibility_subscription', false);
  }
}
async function fetch_user(context) {
  try {
    let { data: user, status: status } = await axios.get("/init");
    if (status == 200) {
      context.commit('set_user', user);
      // display edit user dialog
      context.commit('set_edit_user_profile_dialog', {
          'show': user.show_update_info_dialog ?? false,
          'title': 'Please update and confirm personal information.',
      });
      await check_agent_subscription(user, context);
      const isPodManager = user.pod_owner_id == user.id;
      context.commit('set_pod_manager_status', isPodManager);
      showHideSideMenu(user);
    } else {
      context.commit('set_user', null);
      context.commit('set_pod_manager_status', false);
    }
    return true;
  } catch (error) {
    console.error('Users login validation failed');
    console.error(error);
    return false;
  }
}

async function attempt_user_login(context, { email, password }) {

    try{

        reset_state(context);
        let csrf = await axios.get("/sanctum/csrf-cookie");

        let { data: user } = await axios.post("/login", { email, password });
        console.log('user', user);

        context.commit('set_user', user);

        return true;

    }catch(error){
        console.error('Users login request failed');
        console.error(error);

        return error.response.data;
    }
}

async function forgotPassword(context, { email }) {

  try{
      let { data: user } = await axios.post("/forgotpassword" , { email });
      console.log('user', user);

      context.commit('set_user', user);

      return true;

  }catch(error){
      console.error('Users forgot password request failed');
      console.error(error);

      return error.response.data;
  }
}


async function resetPassword(context, { password , password_confirmation , token}) {

  try{
      let { data: user } = await axios.post(`/password/reset` , { password , password_confirmation ,token });
      if (user === "Password reset successfully") {
        return true;
    }
      console.log('user', user);

      return user;

  }catch(error){
      console.error('Users forgot password request failed');
      console.error(error);

      return error.response.data;
  }
}


/**
 * load document_requests from document_requests table
 *
 * @param context
 * @param payload
 * @returns {Promise<boolean>}
 */
async function fetch_client_document_requests(context, payload) {
    try {
        let url = '/api/v1' + payload.url;
        let document_requests = {};
        const response = await axios.get(url);
        if (response.data) {
            document_requests = response.data;
        }
        context.commit('fetch_client_document_requests', document_requests);

        return true;
    } catch (error) {
        console.log('catched');
        console.error('document requests request failed');
        console.error(error);
    }
    return false;
}

async function fetch_assessment(context) {

    try{
        let application_id = context.getters.application_status.id;

        let dialogExisted = context.getters.application_update_status_dialog.application ?? null; //Check if status dialog has been created.
        if (dialogExisted) {
          application_id = dialogExisted.id; //reassign the application id
        }

        if(application_id == null){
            console.error('Application assessment not available for unsaved application');
            return false;
        }

        context.commit('set_assessment', { decision_engines: [], options: [] });
        let { data: assessment } = await axios.get(`/api/v1/application/${application_id}/assessment`);

        context.commit('set_assessment', assessment);
        return true;

    }catch(error){
        console.error('Application assessment request failed');
        console.error(error);

        return error.response && error.response.data;
    }
}

async function fetch_ml_assessment(context,force=false) {
  try {
    let digitValueForce = force ? 1 : 0;
    let application_id = context.getters.application_status.id;
    let dialogExisted = context.getters.application_update_status_dialog.application ?? null; //Check if status dialog has been created.
    if (dialogExisted) {
      application_id = dialogExisted.id;
    }
    if (application_id == null){
      console.error('Application assessment not available for unsaved application');
      return false;
    }
    context.commit('set_ml_assessment', { decision_engines: [], options: [] });
    let { data: ml_assessment }  = await axios.get(`/api/v1/application/${application_id}/mlassessment/${digitValueForce}`);
    context.commit('set_ml_assessment', ml_assessment);
    return true;
  } catch(error) {
    console.error('Application ML assessment request failed');
    console.error(error);
    throw error;
  }
}

async function fetch_fresh_assessment(context) {

    try{
        let application_id = context.getters.application_status.id;
        if(application_id == null){
            console.error('Application assessment not available for unsaved application');
            return false;
        }

        context.commit('set_assessment', { decision_engines: [], options: [] });
        let { data: assessment } = await axios.get(`/api/v1/application/${application_id}/assessment/fresh`);

        context.commit('set_assessment', assessment);
        return true;

    }catch(error){
        console.error('Application assessment request failed');
        console.error(error);

        return error.response && error.response.data;
    }
}

/**
 * Fetches the cut-off day from the server and updates the Vuex store.
 *
 * @param {Object} context - The Vuex context object, providing access to `commit`.
 * @returns {boolean} - True if the request succeeds, false otherwise.
 */
async function get_cut_off_day({ commit }) {
  try {
    const response = await axios.get('/api/v1/get_cut_off_day');
    if (response.status === 200) {
      commit('set_cut_off_day', response.data.cutOffDay);
      return true;
    }
    return false;
  } catch (error) {
    console.error("Loading cut off day request failed", error.response);
    return error.response;
  }
}

/**
 * Saves the cut-off day to the server.
 *
 * @param {Object} context - The Vuex context object, providing access to `state`.
 * @returns {boolean} - True if the save is successful, false otherwise.
 */
async function save_cut_off_day({ commit }, cutOffDay) {
  try {
    const response = await axios.post('/api/v1/save_cut_off_day', {
      cutOffDay: cutOffDay,
    });

    if (response.status === 200) {
      commit('set_cut_off_day', cutOffDay);
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Setting cut off day request failed", error.response);
    return error.response;
  }
}

/**
 * fetch_veda_report - Fetch stored veda for primary applicant.
 * @param {*} context
 * @param {*} payload Consists of properties: 'loan_application_id' and 'is_action_veda'
 * @returns {Promise<boolean>}
 */
async function fetch_veda_report(context, payload) {
  try {
      const loan_application_id = payload.loan_application_id ?? null
      const is_auction_veda = payload.is_auction_veda ?? 0
      if (loan_application_id == null) {
          console.error('Application credit report not available');
          return false;
      }
      let response = await axios.get(`/api/v1/application/${loan_application_id}/veda_report/${is_auction_veda}`);
      context.commit('set_veda_report', response.data);
      return true;
  } catch (error) {
      console.error('Veda request failed');
      console.error(error);

      return error.response && error.response.data;
  }
}

async function delete_doc_template(context, payload) {
    try {
        console.log('payload: ', payload);
        const response = await axios.post('/api/v1/delete-doc-template', payload);

        if (response.status === 200) {
            await fetch_doc_templates(context);
        }

        return response.data;
    } catch (error) {

        console.error('Application assessment request failed');
        console.error(error);

        return false;
    }
}

/**
 *
 * @param context
 * @param payload
 * @returns {Promise<boolean|any>}
 */
async function get_compliance_checklists(context, id){
    try{
        const response = await axios.get(`/api/v1/application/${id}/get_compliance_checklist`);
        return response.data;
    }catch(e){
        console.error(e);
        return false;
    }
}
/**
 *
 * @param {*} context
 * @param {*} force
 * @returns
 */
async function fetch_administration_brokers(context, force = false) {
    if (force || !context.state.administration_brokers) {

        try {
            let response = await axios.get('/api/v1/administration/brokers');
            context.commit('set_administration_brokers', response.data);
            return true;
        } catch (error) {
            console.error('Broker request failed');
            console.error(error);
            return false;
        }
    } else {
        return true;
    }
}

async function fetch_administration_billings(context, force = false) {
  if (force || !context.state.administration_billings) {
    try {
      let response = await axios.get("/api/v1/administration/billings");
      context.commit("set_administration_billings", response.data);
      return true;
    } catch (error) {
      console.error("Billings request failed");
      console.error(error);
      return false;
    }
  } else {
    return true;
  }
}

async function save_administration_billings(context, payload) {
    try {
      let response = await axios.post(
        `/api/v1/administration/billings`,payload
      );
      return response;
    } catch (error) {
      console.error("Billings save request failed");
      console.error(error.response);
      return error.response;
    }
}

async function fetch_administration_billing_detail(context, id) {
  try {
    let response = await axios.get(`/api/v1/administration/billings/${id}`);
    return response;
  } catch (error) {
    console.error("Billings fetch request failed");
    console.error(error.data);
    return false;
  }
}

async function remove_administration_billing_detail(context, id) {
  try {
    let response = await axios.delete(`/api/v1/administration/billings/${id}`);
    return response;
  } catch (error) {
    console.error("Billings delete request failed");
    console.error(error);
    return error.response;
  }
}

/**
 *
 * @param {*} context
 * @param {*} force
 * @returns
 */
async function fetch_administration_introducers(context, force = false) {
  if (force || !context.state.administration_introducers) {

    try {
      let response = await axios.get('/api/v1/administration/introducers');
      context.commit('set_administration_introducers', response.data);
      return true;
    } catch (error) {
      console.error('introducers request failed');
      console.error(error);
      return false;
    }
  } else {
    return true;
  }
}

/**
 *
 * @param {*} context
 * @param {*} force
 * @returns
 */
async function fetch_administration_glass_prices(context, force = false) {
    if (force || !context.state.administration_glass_prices) {

        try {
            let response = await axios.get('/api/v1/administration/glass_prices');
            context.commit('set_administration_glass_prices', response.data);
            return true;
        } catch (error) {
            console.error('Glass prices request failed');
            console.error(error);
            return false;
        }
    } else {
        return true;
    }
}

/**
 *
 * @param {*} context
 * @param {*} force
 * @returns
 */
 async function fetch_referrals(context) {
    try {
      let response = await axios.get('/api/v1/application/getReferrers');
      context.commit('set_introducers', response.data);
      return true;
    } catch (error) {
      console.error('introducers request failed');
      console.error(error);
      return false;
    }
}

/**
 * ppsr search
 *
 * @param context
 * @param payload
 * @returns {Promise<boolean|T>}
 */
async function request_by_ppsr(context, payload) {

  // default use Equifax ppsr query
  let url = "/api/v1/application/fetch_ppsr";

  if (payload.ppsr_type == 'algodriven') {
    url = "/api/v1/application/request_ppsr";
  }

  await axios.post(url, payload)
    .then((res)=>{
        context.commit('FETCH_PPSR_SEARCH_RESULT', res.data);
      }
    ).catch((error) => {
        console.error('request_by_ppsr() request failed');
        console.error(error);
        throw error;
      }
    );
  return true;
}

/**
 * ppsr loading from database
 *
 * @param context
 * @param payload
 * @returns {Promise<boolean>}
 */
async function fetch_ppsr_search_result(context, payload) {
  try {
    let ppsr_response = null;
    const response = await axios.post('/api/v1/application/fetch_ppsr', payload);
    if (response.data) {
      ppsr_response = response.data;
    }
    context.commit('FETCH_PPSR_SEARCH_RESULT', ppsr_response);

    return true;
  } catch (error) {
    console.error('get ppsr search result failed');
    console.error(error);
  }

  return false;
}

/**
 * ppsr loading from database
 *
 * @param context
 * @param payload
 * @returns {Promise<boolean>}
 */
async function check_ppsr_status(context, payload) {
    let ppsr_response = null;
    await axios.post('/api/v1/application/check_ppsr_status', payload)
      .then((res)=>{
        context.commit('PPSR_STATUS_RESULT', res.data);
      })
      .catch((error) => {
        console.error('check ppsr status request failed');
        console.error(error);
        throw error;
      });

    return true;
}

/**
 * get billings from the database
 * @param context
 * @returns {Promise<any>}
 */
async function get_billings(context, payload) {
  if (payload.force || !context.state.billings) {
    try {
      const response = await axios.post('/api/v1/administration/get_billings', payload);
      context.commit('set_billings', response.data);
      // SDB-1020 move warranty deals to rcti table
      // await context.dispatch('get_warranty_billings', payload);
      return true;
    } catch (error) {
      console.error('get billings failed');
      console.error(error);
    }
  }
  return true;
}

/**
 * get warranty billings from the database
 * @param { commit }
 * @returns Promise<boolean>
 */
async function get_warranty_billings({ commit }, payload) {
  if (this.isReferrerFiltering) {
    commit('set_warranty_billings', []);
    return true;
  }
  try {
    let res = await axios.post('/api/v1/administration/get_warranty_billings', {
      selected_year: payload.selected_year,
      selected_month: payload.selected_month,
      selected_pod: payload.selected_pod,
    });
    commit('set_warranty_billings', res.data["bills"]);
    return true;
  }
  catch (error) {
    console.error(error);
    return false;
  }
}

/**
 * get referral expenses record for month/year
 * @param context
 * @param payload
 * @returns {Promise<boolean>}
 */
async function get_referral_billings(context, payload) {
  try {
    const response = await axios.post('/api/v1/administration/get_referral_billings', payload);
    context.commit('set_billings', response.data);
    return true;
  } catch (error) {
    console.error('get billings failed');
    console.error(error);
  }

  return true;
}

// Commented on task SDB-534 for future implementation
/**
 * get referral expenses record for month/year
 * @param context
 * @param payload
 * @returns {Promise<boolean>}
 */
// async function get_total_referral_amount(context, payload) {
//   try {
//     const response = await axios.post('/api/v1/administration/get_total_referral_amount', payload);
//     context.commit('set_billings', response.data);
//     return true;
//   } catch (error) {
//     console.error('get total referral amount failed');
//     console.error(error);
//   }
//   return true;
// }

/**
 * modify document request verify and update application
 *
 * @param context
 * @param payload
 * @returns {Promise<boolean>}
 */
async function fetch_modify_doc_uploaded_verify(context, payload) {
  try {
    let application = null;
    const response = await axios.post('/api/v1/application/fetch_docs_verify', payload);
    if (response.data) {
      application = response.data;
    }
    context.commit('set_selected_application', application);
    return true;
  } catch (error) {
    console.error('get ppsr search result failed');
    console.error(error);
  }

  return false;
}

async function decline_document(context, payload) {
  try {
    const response = await axios.post('/api/v1/application/decline_document', payload);
    return response;
  } catch (error) {
    console.error('Delete Document Failed');
    console.error(error);
    return false;
  }
}

async function get_xero_contacts(context, query) {
  try{
    const response = await axios.post(`/api/v1/xero/get_xero_contacts`, {searchQuery: query});
    return response;
  } catch (e) {
    console.error('get xero contacts error');
    console.error(e);
  }
}

/**
 * Search for user based on query.
 *
 * @param {Object} query
 * @returns {Promise}
 */
async function search_user(_, query) {
  try{
    const response = await axios.post(`/api/v1/user/search`, { query });
    return response;
  } catch (e) {
    console.error('Error fetching users');
    console.error(e);
  }
}

/**
 * Fetch a user by ID.
 *
 * @param {number|string} id - The ID of the user to be fetched.
 * @returns {Promise}
 */
async function fetch_user_by_id(_, id) {
  try{
    const response = await axios.get(`/api/v1/administration/users/${id}`);
    return response;
  } catch (e) {
    console.error('Error fetching users');
    console.error(e);
  }
}

async function get_xero_tracking_code(context, query) {
  try{
    const response = await axios.get(`/api/v1/xero/get_xero_tracking_code/${query}`);
    return response;
  } catch (e) {
    console.error('get xero tracking code error');
    console.error(e);
  }
}
/**
 * reload upload documents page
 *
 * @param context
 * @param payload
 * @returns {Promise<boolean>}
 */
async function reload_document(context, payload) {
  try {
    let full_application = payload.full_application;
    let uploaded_documents = payload.uploaded_documents;

    context.commit('set_selected_application', full_application);
    context.commit('set_uploaded_documents', uploaded_documents);

    return true;
  } catch (error) {
    console.error('get ppsr search result failed');
    console.error(error);
  }

  return false;
}

/**
 * land title search by current address and
 * current address is owned or morgaged
 *
 * @param context
 * @param payload
 * @returns {Promise<boolean|T>}
 */
async function request_land_title_by_current_address(context, payload) {
  try{
    let land_title_response = null;
    let response = await axios.post("/api/v1/application/request_land_title", payload);
    if (response.data) {
      land_title_response = response.data;
    }
    context.commit('set_land_title_search_result', land_title_response);

    return true;
  } catch (error) {
    console.error(error);
    context.commit('set_land_title_search_result', null);
    return error.response.data;
  }
}

/**
 * land title search for investment property
 *
 * @param context
 * @param payload
 * @returns {Promise<boolean|T>}
 */
async function request_land_title_by_investment_property(context, payload) {
  try {
    let land_title_response = null;
    const response = await axios.post("/api/v1/application/request_land_title_for_investment_property", payload);
    if (response.data) {
      land_title_response = response.data;
    }
    context.commit('set_land_title_search_result', land_title_response);

    return true;
  } catch (error) {
    console.error(error);
    context.commit('set_land_title_search_result', null);
    return error.response.data;
  }
}

/**
 * land title document request by reference
 *
 * @param context
 * @param payload
 * @returns {Promise<boolean|T>}
 */
async function request_land_title_document(context, payload) {
  try{
    let response = await axios.post("/api/v1/application/request_land_title_document", payload);
    if (response.data) {
      return response.data;
    }
    return false;
  } catch (error) {
    throw error.response.data;
  }
}

/**
 * ppsr loading from database
 *
 * @param context
 * @param payload
 * @returns {Promise<boolean>}
 */
async function fetch_land_title_search_result(context, payload) {
  try {
    let land_title_response = null;
    const response = await axios.post('/api/v1/application/fetch_land_title', payload);
    if (response.data) {
      land_title_response = response.data;
    }
    context.commit('set_land_title_search_result', land_title_response);
    return true;
  } catch (error) {
    console.error('get ppsr search result failed');
    console.error(error);
  }

  return false;
}

async function submit_generate_application_document(context, payload) {
  try {
    let loanId = payload.application.loan.id;
    const response = await axios.post(`/api/v1/application/${loanId}/generateApplicationForm`, payload);
    context.commit('set_selected_application', payload.application);
    return true;
  } catch (error) {
    console.error('generate application document failed');
    console.error(error);
  }
}

async function broker_edit_document_type(context, payload) {
  try {
    const response = await axios.post(
      "/api/v1/application/broker_edit_document_type",
      {
        document_type_name: payload.document_type,
        application_id: context.getters.application.loan.id,
        document_id: payload.id,
      }
    );
    return response;
  } catch (error) {
    console.error("Edit document type request failed");
    console.error(error);
    return error.response;
  }
}

/**
 * load make by model year
 *
 * @param context
 * @param payload
 * @returns {Promise<void>}
 */
async function load_make(context, payload) {
  try {
    const response = await axios.post('/api/v1/get_make_by_year', payload);
    context.commit('set_maker', response.data);
    return response.data;
  } catch (error) {
    console.error('Make is not available');
    console.error(error);
  }
}

/**
 * load make by model year
 *
 * @param context
 * @param payload
 * @returns {Promise<void>}
 */
async function load_all_make(context, payload) {
  try {
    const response = await axios.post('/api/v1/get_makes_data', payload);
    context.commit('set_all_maker', response.data);
    return response.data;
  } catch (error) {
    console.error('Make is not available');
    console.error(error);
  }
}

/**
 * load model by model year and make
 *
 * @param context
 * @param payload
 * @returns {Promise<void>}
 */
async function load_model(context, payload) {
  try {
    const response = await axios.post('/api/v1/get_model_by_year_make', payload);
    context.commit('set_model', response.data);
    return response.data;
  } catch (error) {
    console.error('Model is not available');
    console.error(error);
  }
}

/**
 * load model by model year and make
 *
 * @param context
 * @param payload
 * @returns {Promise<void>}
 */
async function load_model_make(context, payload) {
  try {
    const response = await axios.post('/api/v1/get_model_by_make', payload);
    context.commit('set_model_make', response.data);
    return response.data;
  } catch (error) {
    console.error('Model is not available');
    console.error(error);
  }
}

/**
 * load introducer detail
 * @param payload
 * @returns {Promise<void>}
 */
 async function load_introducer(context, payload) {
  try {
    const response = await axios.post('/api/v1/get_introducer_data', payload);
    return response;
  } catch (error) {
    console.error('Introducer is not exist');
    console.error(error);
  }
}

/**
 * load glass data by model_year, make and model
 *
 * @param context
 * @param payload
 * @returns {Promise<void>}
 */
async function load_glass_data(context, payload) {
  try {
    const response = await axios.post('/api/v1/get_glass_data', payload);
    context.commit('set_glass', response.data);

  } catch (error) {
    console.error('glass is not available');
    console.error(error);
  }
}

/**
 * clear the maker and model
 *
 * @param context
 * @returns {Promise<void>}
 */
async function clear_maker(context) {
  context.commit('clear_maker');
}

/**
 * clear the model
 *
 * @param context
 * @returns {Promise<void>}
 */
async function clear_model(context) {
  context.commit('clear_model');
}

/**
 * pick and set the vechile value, NVIC, variant and series value.
 *
 * @param context
 * @param payload
 * @returns {Promise<void>}
 */
async function set_vehicle_value(context, payload) {
    context.commit('set_nvic_price', payload);
}

async function copyFromApplicant1(context, payload) {
    context.commit('copy_from_applicant1', payload);
}

async function generate_document(context, payload) {
  const result = await axios.post('/api/v1/generate_document', payload)
    .then(response => {
      context.commit('set_selected_application', response.data.full_application);
      context.commit('set_uploaded_documents', response.data.uploaded_documents);
      return response;
    })
    .catch((error) => {
      console.error('failed to generate documents');
      console.error(error);
      throw error;
    });

  return result;
}

async function generatable_template(context, payload) {
  try {
    const response = await axios.post('/api/v1/generatable_template', payload);

    return true;
  } catch (error) {
    console.error('failed to change generatable template');
    console.error(error);
  }
}

async function generate_tax_invoice_request(context, application_id) {
  try {
    const response = await axios.post(`/api/v1/application/${application_id}/generate_tax_invoice_request`);
    return response.data.success;
  } catch (e) {
    console.error('error generating tax invoice');
    console.error(e);
  }
}

async function generate_settlement_documents(context, payload) {
  try {
    const response = await axios.post(`/api/v1/application/${payload.application_id}/generate_compliance_documents/${payload.settlement_id}/${payload.sendForSignature}`);
    return response;
  } catch (e) {
    console.error('error generating settlement documents');
    console.error(e);
    throw e;
  }
}

/**
 * function to update the status of the application
 * @param context
 * @param payload
 * @returns {Promise<any>}
 */
async function update_application_status(context, payload){
  try {
    const response = await axios.post(`/api/v1/application/${payload.application_id}/status`, {
      stage: payload.stage,
      status: payload.status,
      reason: payload.reason,
      comment: payload.comment
    });
    context.commit('set_application_status',payload);
    return response.data;
  } catch (e) {
    console.error('error in update_application_status()');
    console.error(e);
    throw e;
  }
}

/**
 * send document to docusign
 *
 * @param context
 * @param payload
 * @returns {Promise<AxiosResponse<any>|T>}
 */
async function send_document_to_docusign(context, payload) {
  try {
    const response = await axios.post('/api/v1/send_document_to_docusign', payload);
    return response.data;
  } catch (e) {
    console.error('error generating settlement documents');
    console.error(e);
    throw e;
  }
}

/**
 * send email with attached document to Applicant
 *
 * @param context
 * @param payload
 * @returns {Promise<AxiosResponse<any>>}
 */
async function send_email_to_customer(context, payload) {
  try {
    const response = await axios.post('/api/v1/send_email_to_customer', payload);
    return response.data;
  } catch (e) {
    console.error('error generating settlement documents');
    console.error(e);
    throw e;
  }
}

/**
 * send email with attached document to Lender
 *
 * @param context
 * @param payload
 * @returns {Promise<AxiosResponse<any>>}
 */
async function send_email_to_lender(context, payload) {
  try {
    const response = await axios.post('/api/v1/send_email_to_lender', payload);
    return response.data;
  } catch (e) {
    console.error('error generating settlement documents');
    console.error(e);
    throw e;
  }
}

/**
 * download document(s) as Zip file
 *
 * @param context
 * @param payload
 * @returns {Promise<AxiosResponse<any>>}
 */
async function download_as_zip(context, payload) {
  try {
    const response = await axios.post('/api/v1/download_as_zip', payload);
    return response.data;
  } catch (e) {
    console.error('error generating settlement documents');
    console.error(e);
    throw e;
  }
}

/**
 * delete temporary Zip file
 *
 * @param context
 * @param payload
 * @returns {Promise<AxiosResponse<any>>}
 */
async function delete_temp_zip(context, payload) {
  try {
    const response = await axios.post('/api/v1/delete_temp_zip', payload);
    return response.data;
  } catch (e) {
    console.error('error deleting the zip file');
    console.error(e);
    throw e;
  }
}

/**
 *
 * generate brokerage and commission invoice
 *
 * @param context
 * @param application_id
 * @returns {Promise<*>}
 */
async function generate_brokerage_commission_invoice(context, application_id) {
  try {
    const response = await axios.post(`/api/v1/application/${application_id}/generate_brokerage_commission_invoice`);
    return response.data;
  } catch (e) {
    console.error('error generating brokerage & commission invoice');
    console.error(e);
  }
}

/**
 * save submission data
 * @param context
 * @param submission
 * @returns {Promise<void>}
 */
async function update_submission_data(context, payload) {
  try {
    const response = await axios.post('/api/v1/application/update_submission', payload);
    return response.data;
  } catch (e) {
    console.error('error in update_submission_data()');
    console.error('er:', e.response.data.error);
  }
}


async function upload_documents_to_lender(context, payload) {
  try {
    let application_id = payload.application_id;
    const response = await axios.post(`/api/v1/application/${application_id}/upload-documents-to-lender`, payload);

    if (response.data && payload.lender == "Finance One") {
      context.commit('set_fin1_uploaded_document', response.data.data.data.uuid);
    }

    return response.data;
  } catch (e) {
    console.error('error in update_submission_data()');
    console.error('err:', e.response.data);
    throw e;
  }
}

async function get_hem_living_expense(context) {
  try {
    const response = await axios.get(`/api/v1/administration/hem-living-expense`);
    context.commit('set_hem_living_expense_access', true);
    context.commit('set_hem_living_expense', response.data);
    return response.data;
  } catch (e) {
    context.commit('set_hem_living_expense_access', false);
    console.error('error, dont have access to upload hem living expense');
    console.error('err:', e.response.data);
    throw e;
  }
}

async function upload_hem_living_expense(context, payload) {
  try {
    const response = await axios.post(`/api/v1/administration/hem-living-expense`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    });
    return response.data;
  } catch (e) {
    console.error('error in uploading hem living expense');
    console.error('err:', e.response.data);
    throw e;
  }
}

async function pepper_v3_check_status_submit_to_lender(context, payload) {
  try {
    const application_id = payload.application_id;
    const processName = payload.processName;
    const response = await axios.post(
      `/api/v1/application/${application_id}/submit/api/${processName}`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
}

async function reset_advance_filter(context){
  context.commit('set_advance_search_application', {
    show : false,
    active : false,
    brokers:[],
    stage: [],
    statuses:[],
    lenders:[],
    loan_asset_types:[],
    pod : [],
    introducers:[],
    start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
    end_date :  moment().format('YYYY-MM-DD'),
    pods:[],
    get_empty_broker: false,
    get_empty_introducer: false,
    get_empty_lender: false,
    applicant_type: null
  });
}

async function save_basket_search_filter(context, payload) {
  try {
    let response = await axios.post(`/api/v1/application/basket/save_filters`, context.state.advance_search_application);
      return true;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

async function get_basket_search_filter(context, payload) {
  if (
    context.state.user.search_filter &&
    context.state.user.search_filter.length > 0
  ) {
    const filters = JSON.parse(
      context.state.user.search_filter[0].search_filters
    );
    filters.active = true;
    context.commit("set_advance_search_application", filters);
  }
}

/**
 * function to get data from reporting getter
 * @param context
 * @param payload
 * @returns {Promise<boolean|*>}
 */
async function ensure_reporting_meta_data(context, payload) {
  if(payload.basedOnSettlement) {
    if (!context.getters.reportingMetaDataSettlementBased || payload.force) {
      return await get_reporting_meta_data(context, payload);
    }
    return context.getters.reportingMetaDataSettlementBased;
  } else {
    if (!context.getters.reportingMetaDataAppBased || payload.force) {
      return await get_reporting_meta_data(context, payload);
    }
    return context.getters.reportingMetaDataAppBased;
  }
}

/**
 * function to get data from reporting getter
 * @param context
 * @param force
 * @returns {any}
 */
async function ensure_pre_graph_data(context, force) {
  if (!context.getters.preGraphData || force) {
    return await get_pre_graph_data(context);
  }
  return context.getters.preGraphData;
}

/**
 * function to get data from reporting getter
 * @param context
 * @param payload
 * @returns {any}
 */
async function ensure_active_applications_graph_data(context, payload) {
  if (!context.getters.activeAppsGraphData || payload.force) {
    return await get_active_applications_graph_data(context, payload);
  }
  return context.getters.activeAppsGraphData;
}

/**
 * function to get reporting data
 * @returns {Promise<any>}
 */
async function get_reporting_meta_data(context, payload) {
  try {
    let response = await axios.post('/api/v1/reporting/getMetaData', {filter: payload});
    if (payload.basedOnSettlement) {
      context.commit('set_reporting_meta_data_settlement_based', response.data);
      return response.data;
    } else {
      context.commit('set_reporting_meta_data_app_based', response.data);
      return response.data;
    }
  } catch (e) {
    console.log("error in get_reporting_meta_data");
    console.error(e);
  }
}

/**
 * function to populate filters and other graphicalData
 * @returns {Promise<any>}
 */
async function get_pre_graph_data(context) {
  try {
    let response = await axios.get('/api/v1/reporting/getPreGraphData');
    context.commit('set_pre_graph_data', response.data);
    return response.data;
  } catch (e) {
    console.log("error in get_pre_graph_data");
    console.error(e);
  }
}

/**
 * function to get active applications graph data
 * @param context
 * @param payload
 * @returns {Promise<any>}
 */
async function get_active_applications_graph_data(context, payload) {
  try {
    let response = await axios.post('/api/v1/reporting/getWorkBasket', {filter: payload});
    context.commit('set_active_applications_graph_data', response.data);
    return response.data;
  } catch (e) {
    console.log("error in get_active_applications_graph_data");
    console.error(e);
  }
}

async function open_comment_dialog(context, application){
    await load_application(context,application.id);
    context.commit("set_application_comment_dialog", application);
}

/**
 * clone application
 * @param context
 * @param application
 * @returns {Promise<void>}
 */
async function clone_loan_application(context, payload){
  try{
    const response = await axios.post(`/api/v1/application/${payload.application_id}/clone`, {
      includeComment : payload.includeComment,
      includeDocs : payload.includeDocs,
    });
    context.commit('set_selected_application', response.data);
    return response.data;
  } catch (e) {
    console.error('error in clone_loan_application()');
    console.error('err:', e);
    throw e;
  }
}

/**
 * function to export drive leads
 * @returns {Promise<any>}
 */
async function export_drive_leads() {
  try {
    const response = await axios.post('/api/v1/document/basket/drive_export');
    return response.data;
  } catch (e) {
    console.error('error in export_drive_leads()');
    console.error('err:', e);
    throw e;
  }
}

/**
 * Exports the Approval Pull-Through Report data.
 * Sends a request to generate and email the report asynchronously.
 *
 * @returns {Promise<any>} Resolves with the API response or rejects on error.
 */
async function export_approval_pull_through(_, payload) {
  try {
    const response = await axios.post("/api/v1/reporting/getApprovalPullThroughCSV", {
      csvData: payload.csvData,
      funnelType: payload.funnelType
    });

    return response.data;
  } catch (error) {
    console.error("Export Error:", error);
    throw error;
  }
}

async function get_broker_query (context,force=false) {
  if (force || !context.state.administration_brokers) {
    let {data: users} = await axios.get(`/api/v1/administration/users_by_roles/broker`);
    context.commit('set_administration_brokers', users);
  }
}

async function get_referrer_query (context,force=false) {
  if (force || !context.state.administration_introducers) {
    let {data: users} = await axios.get(`/api/v1/administration/users_by_roles/referrer`);
    context.commit('set_administration_introducers', users);
  }
}

async function get_agent_query (context,force=false) {
  if (force || !context.state.administration_agents) {
    let {data: users} = await axios.get(`/api/v1/administration/users_by_roles/agent`);
    context.commit('set_administration_agents', users);
  }
}

async function get_all_types_agents_query (context,force=false) {
  if (force || !context.state.all_types_agents) {
    let {data: agents} = await axios.get(`/api/v1/administration/get_all_types_agents`);
    context.commit('set_all_types_agents', agents);
  }
}

async function get_lender_query (context,force=false) {
  if (force || !context.state.administration_lenders) {
    let {data: users} = await axios.get(`/api/v1/application/getAllLenders`);
    context.commit('set_administration_lenders', users);
  }
}

async function get_default_ownership (context) {
  try {
    const response = await axios.get('/api/v1/get_default_ownership');
    context.commit('set_owners', response.data);
    return true;
  } catch (e) {
    console.error(e);
    throw e;
  }
}

async function toggle_lender_setting(context, payload) {
  try {
    let response = await axios.post('/api/v1/administration/toggle_lender_setting', payload);
    return response.data;
  } catch (e) {
    console.error(e);
  }
}

/**
 * @desc Toggle visibility of Submit to Lender form,
 * @param context
 * @param payload
 */
function toggle_submit_to_lender_form(context, payload){
  context.commit('set_submit_to_lender_form_visibility', payload);
}


async function request_cross_match(context, {
  application_data,
  applicant_index,
  possibleMatchId
}) {

  reset_state_on_application_save(context);

  try {

    await save_application(context, application_data);
    context.commit('setApplicationStatus', {
      loading: true,
    });

    let applicant = context.getters.application.applicants[applicant_index];
    let {
      data: result
    } = await axios.post(`/api/v1/applicant/${applicant.id}/request_cross_match`,  {
      id: possibleMatchId
    });
    let application = result['application'];
    if (result['success']) {
      application.applicants[0] = addressFromVeda(application.applicants[0]);
    }
    context.commit('set_selected_application', application);
    context.commit('setApplicationStatus', {
      loading: false,
      dirty: false,
    });
    return result;
  } catch (error) {
    console.error('request cross match request failed');
    console.error(error);

    if (error.response.status == 419) {
      window.vue.$modal.show(LoginDialog);
    }
    context.commit('setApplicationStatus', {
      loading: false,
    });
    throw error;
  }
}
async function send_isread_value(context, payload){
  try {
    const response = await axios.post('/api/v1/application/fetch_isread_value', payload);
    return response;
  } catch (error) {
    console.error('getting is_read value failed');
    console.error(error);
  }

  return false;
}
async function remove_glass_price(context, payload){
    try {
        const response = await axios.post('/api/v1/remove_glass_prices', payload);
        return response;
    } catch (error) {
        console.error('Remove glass price failed');
        console.error(error);
    }

    return false;
}
async function request_documents_via_email(context, payload) {

  reset_state_on_application_save(context);
  try {
    await save_application(context, payload.application_data);
    context.commit('setApplicationStatus', {
      loading: true,
    });
    const postData = {
      generateLink: Boolean(payload.generateLink),
      documentRequests: payload.document_requests,
      onApplicationPage: Boolean(payload.onApplicationPage)
    };
    let {
      data: response
    } = await axios.post(`/api/v1/applicant/${payload.applicantId}/document-request/email`, postData);
    if (response) {
      context.commit('set_selected_application', response);
      context.commit('setApplicationStatus', {
        loading: false,
        dirty: false,
      });
    }

    return response;
  } catch (error) {
    console.error('document request via email failed');
    context.commit('setApplicationStatus', {
      loading: false,
    });
    console.error(error);
    throw error;
  }
}

async function on_loan_details_requested_amount_tab_key_pressed(context, isLoanDetailsRequestedAmountTabKeyPressed) {
  context.state.is_loan_details_requested_amount_tab_key_pressed = isLoanDetailsRequestedAmountTabKeyPressed;
}

async function request_documents_via_sms(context, payload) {

  reset_state_on_application_save(context);
  try {
    await save_application(context, payload.application_data);
    context.commit('setApplicationStatus', {
      loading: true,
    });
    const postData = {
      generateLink: Boolean(payload.generateLink),
      onApplicationPage: Boolean(payload.onApplicationPage)
    };
    let {
      data: response
    } = await axios.post(`/api/v1/applicant/${payload.applicantId}/document-request/sms`, postData);
    if (response) {
      context.commit('set_selected_application', response);
      context.commit('setApplicationStatus', {
        loading: false,
        dirty: false,
      });
    }
    return response;
  } catch (error) {
    console.error('document request via sms failed');
    context.commit('setApplicationStatus', {
      loading: false,
    });
    console.error(error);
    throw error;
  }
}

/**
 * @desc Get Users who are having role as Agent
 * @param {*} context
 * @param {*} force
 * @returns
 */
async function fetch_administration_agents(context) {
  try {
    let response = await axios.get('/api/v1/administration/agents');
    context.commit('set_administration_agents', response.data);
    return true;
  } catch (error) {
    console.error('Agents request failed');
    console.error(error);
    return false;
  }
}

/**
 * @desc Address Search API call
 * @param context
 * @param payload
 */
async function performSearchAddress(context, params) {
  try {
    let response = await axios.get('/api/v1/sensis/address/search',  { params, maxRedirects:0 });
    return response;
  } catch(error) {
    console.error(error);
  }
}

/**
 * @desc NVIC Search API call
 * @param context
 * @param payload
 */
async function performSearchNvic(context, params) {
    try {
        let response = await axios.get('/api/v1/get_nvic_data',  { params, maxRedirects:0 });
        return response;
    } catch(error) {
        console.error(error);
    }
}

/**
 *
 * @param {*} context
 * @param {*} force
 * @returns
 */
 async function fetch_administration_adjustments(context, force = false) {
  if (force || !context.state.administration_adjustments) {

    try {
      let response = await axios.get('/api/v1/administration/adjustments');
      context.commit('set_administration_adjustments', response.data);
      return true;
    } catch (error) {
      console.error('administration request failed');
      console.error(error);
      return false;
    }
  } else {
    return true;
  }
}

/**
 * @desc Address Details API call
 * @param context
 * @param payload
 */
async function selectAddressMethod(context, params) {
  try {
      let response = await axios.get('/api/v1/sensis/address/details',  { params, maxRedirects:0 });
      return response;
  } catch(error) {
      console.error(error);
  }

}

/**
 * @desc NVIC Details API call
 * @param context
 * @param payload
 */
async function selectNvicMethod(context, params) {
    try {
        let response = await axios.post('/api/v1/glass_prices/' + params);
        return response;
    } catch(error) {
        console.error(error);
    }

}

async function swap_applicant_type(context, payload) {
  try {
    await context.commit("swap_applicant_type", payload);
  } catch (error) {
    console.error(error);
  }
}

async function request_original_credit_report(context, {
  application_data,
  applicant_index,
  possibleMatchId
}) {

  reset_state_on_application_save(context);

  try {

    await save_application(context, application_data);
    context.commit('setApplicationStatus', {
      loading: true,
    });

    let applicant = context.getters.application.applicants[applicant_index];
    let {
      data: result
    } = await axios.post(`/api/v1/applicant/${applicant.id}/request_original_credit_report`,  {
      id: possibleMatchId
    });
    let application = result['application'];
    if (result['success']) {
      application.applicants[0] = addressFromVeda(application.applicants[0]);
    }
    context.commit('set_selected_application', application);
    context.commit('setApplicationStatus', {
      loading: false,
      dirty: false,
    });
    return result;
  } catch (error) {
    console.error('request original credit report request failed');
    console.error(error);

    if (error.response.status == 419) {
      window.vue.$modal.show(LoginDialog);
    }
    context.commit('setApplicationStatus', {
      loading: false,
    });
    throw error;
  }
}

/**
 * @desc Locks the application for current user
 * @param {*} context
 * @param Application Id
 * @returns
 */
async function lock_application(context, application_id) {
  try {
    let {
      data: result
    } = await axios.get(`/api/v1/application/${application_id}/lockApplication`);
    context.commit('setApplicationStatus', {
      locked: false,
    });
    context.commit('set_application_lock_config', {
      duration: result.duration,
      reminder: result.reminder,
    });
    return true;
  } catch(error) {
    return false;
  }
}

/**
 * @desc update application for current user
 * @param {*} context
 * @param Application Id
 * @returns
 */
function updateApplicationNextAction(context, payload) {
  context.commit('set_current_next_action', {
    applicationId: payload.applicationId,
    nextAction: payload.nextAction,
    nextActionDate: payload.nextActionDate
  });
}


/**
 * @desc Checks If application can be locked or not
 * @param {*} context
 * @param Application Id
 * @returns
 */
async function check_application_lock(context, application_id) {
  try {
    await axios.get(`/api/v1/application/${application_id}/checkApplicationLock`);
    context.commit('set_current_lock', {
      messages: null,
      app_id: null
    });
    return true;
  } catch(error) {
    context.commit('set_current_lock', {
      messages: error.response.data,
      app_id: application_id
    });
    return false;
  }
}

/**
 * @desc Release application lock
 * @param {*} context
 * @param Application Id
 * @returns
 */
function release_application_lock(context, application_id) {
  try {
    let response = axios.get(`/api/v1/application/${application_id}/releaseApplicationLock`);
    return response;
  } catch (e) {
    console.error(e);
  }
}

/**
 * @desc Get all live locks call
 * @param {*} context
 * @returns
 */
async function fetch_application_locks(context) {
  try {
    let response = await axios.get('/api/v1/administration/app-locks');
    context.commit('set_application_locks', response.data);
    return true;
  } catch (error) {
    return false;
  }
}

async function fetch_administration_veda_rules (context) {
  const resp = await axios.get('/api/v1/administration/veda_rules').then((resp) => {
    if (resp.data) {
      return resp.data
    }

    return [];
  }).catch((err) => {
    console.log(err)
  })

  return resp
}

/**
 * import hubspot csv
 *
 * @param context
 * @returns {Promise<boolean>}
 */
async function import_hubspot_csv(context, payload) {
  try {
      const config = {
          headers: {'content-type': 'multipart/form-data'}
      }

      const formData = new FormData();
      formData.append('file', payload.file);
      formData.append('type', payload.type);

      const response = await axios.post('/api/v1/administration/import_hubspot_csv', formData, config);
      return response;
  } catch (error) {
      console.error(error);
      const response = {};
      response['status'] = error.response.status;
      response['message'] = error.response.data;
      return response;
  }
}

async function import_suncorp_csv (context, payload) {
  try {
    const config = {
      responseType: 'blob',
      headers: {
        'content-type': 'multipart/form-data',
      }
    }

    const formData = new FormData();
    formData.append('file', payload.file);
    formData.append('action', payload.action);
    if (payload.billed_at_year) {
      formData.append('billed_at_year', payload.billed_at_year);
    }
    if (payload.billed_at_month) {
      formData.append('billed_at_month', payload.billed_at_month);
    }

    const response = await axios.post('/api/v1/administration/suncorp_csv_action', formData, config);
    return response;
  } catch (error) {
    console.error("Failed to import Suncorp Csv.");
    throw error;
  }
}

async function send_quick_response(context, payload) {
  try {
    const response = await axios.post('/api/v1/application/send_quick_response', payload);
    return response.data;
  } catch (error) {
    console.error('Send quick response failed.');
    console.error(error.response ? error.response : error);
    return error.response.data ?? error;
  }
}

async function get_quick_response_content(context, payload) {
  try {
    const response = await axios.post('/api/v1/application/get_quick_response_content', payload);
    return response.data;
  } catch (error) {
    console.error('Get quick response content failed.');
    console.error(error.response ? error.response : error);
    return error.response.data ?? error;
  }
}

/**
 * Subscribes to a Pusher channel and binds an event
 * @async
 * @function subscribe_to_pusher_channel
 * @param {object} context - Vuex context object
 * @param {string} channelName - Channel name which will be subscribed to.
 * @returns {object} An object containing the initialized Pusher instance and bound channel, or null if an error occurs.
 */
async function subscribe_to_pusher_channel(context, channelName) {
  try {
    const pusherResponse = await axios.get('/api/v1/pusher/getPusherInfo');
    const {
      id,
      cluster,
      host,
      port,
      encrypted,
      driver,
      disableStats,
      enabledTransports,
      authEndpoint
    } = pusherResponse.data;

    let pusher;

    if (driver === 'pusher') {
      pusher = new Pusher(String(id), {
        cluster: String(cluster),
        authEndpoint
      });
    } else {
      pusher = new Pusher(String(id), {
        cluster: String(cluster),
        forceTLS: encrypted,
        encrypted: encrypted,
        wsHost: host || undefined,
        wsPort: port || 6001,
        wssPort: port || 6001,
        disableStats,
        enabledTransports,
        authEndpoint
      });
    }

    const channel = pusher.subscribe(channelName);
    return { pusher, channel };
  } catch (error) {
    console.error("Error creating Pusher subscription.");
    console.error(error.response ? error.response : error);
    return { pusher: null, channel: null };
  }
}


/**
 * update the auction notification from pusher
 * @param {object} commit vuex commit
 * @param {array} payload
 */
function update_auction_notification({ commit }, payload) {
  commit('set_auction_notification', payload);
}

/**
 * Update the last auction notification timestamp
 * @param {object} commit vuex commit
 * @param {number} payload
 */
function update_last_auction_notification_timestamp({ commit }, payload) {
  commit('set_last_auction_notification_timestamp', payload);
}

async function get_income_triggers({}, payload) {
  try {
    const result = await axios.post('/api/v1/administration/get_triggerconfigs', payload);
    return result.data;
  } catch (error) {
    console.error("Error retrieving income triggers.");
    const errorMessage = error.response ? error.response : error
    console.error(errorMessage);
    throw error(errorMessage);
  }
}

async function save_income_triggers({}, payload) {
  try{
    const result = await axios.post('/api/v1/administration/save_triggerconfigs', payload);
    return result.data;
  } catch (error) {
    console.error("Error saving income triggers.");
    const errorMessage = error.response ? error.response : error
    console.error(errorMessage);
    throw error(errorMessage);
  }
}

async function generate_preliminary_documents(context, application) {
  try {
    let application_id = context.getters.application_status.id;
    if (application_id == null){
      console.error('Application assessment not available for unsaved application');
      return false;
    }
    let response =  await axios.post(`/api/v1/application/${application_id}/generatePreliminarySystemDocument`, application)
    context.commit('set_preliminary_documents', response.data);
    return true;
  } catch(error) {
    console.error('Application generate preliminary assessment request failed');
    console.error(error);
    throw error;
  }
}

export default {
    broker_edit_document_type,
    get_basket_search_filter,
    save_basket_search_filter,
    swap_applicant_type,
    load_blank_application,
    load_application,
    reload_application,
    ensure_application,
    save_settlement_request,
    fetch_work_basket,
    refresh_work_basket,
    fetch_auction_basket,
    fetch_mql_auction_basket,
    fetch_auction_leads,
    fetch_distribution_auction,
    ensure_work_basket,
    perform_application_search,
    fetch_types,
    invalidate_types,
    fetch_doc_templates,
    store_doc_template,
    store_csv_glass_prices,
    update_application,
    save_application,
    fetch_document_types,
    fetch_document_requests,
    store_request_document_type,
    store_document_requests,
    remove_one_document_request,
    fetch_administration_billings,
    fetch_administration_billing_detail,
    save_administration_billings,
    remove_administration_billing_detail,
    fetch_administration_roles,
    store_administration_roles,
    fetch_administration_users,
    fetch_administration_user_pods,
    fetch_user,
    attempt_user_login,
    forgotPassword,
    resetPassword,
    request_veda_for_application,
    request_voi_for_application,
    backfill_voi,
    submit_application,
    submit_application_via_api,
    submit_application_via_email,
    on_loan_details_requested_amount_tab_key_pressed,
    submit_application_via_url,
    send_email_document_types,
    fetch_client_document_requests,
    fetch_assessment,
    fetch_ml_assessment,
    fetch_fresh_assessment,
    get_audit_log,
    ensure_audit_logs,
    delete_doc_template,
    fetch_doc_uploaded,
    submit_for_compliance,
    get_existing_settlement,
    get_compliance_checklists,
    fetch_administration_brokers,
    reset_state,
    reset_state_on_application_load,
    reset_state_on_application_save,
    request_by_ppsr,
    fetch_ppsr_search_result,
    check_ppsr_status,
    get_billings,
    get_warranty_billings,
    get_referral_billings,
    // Commented on task SDB-534 for future implementation
    // get_total_referral_amount,
    fetch_modify_doc_uploaded_verify,
    decline_document,
    get_xero_contacts,
    search_user,
    get_xero_tracking_code,
    reload_document,
    request_land_title_by_current_address,
    request_land_title_by_investment_property,
    request_land_title_document,
    fetch_land_title_search_result,
    fetch_administration_introducers,
    fetch_administration_glass_prices,
    submit_generate_application_document,
    load_make,
    load_all_make,
    load_model,
    load_model_make,
    load_glass_data,
    set_vehicle_value,
    clear_maker,
    clear_model,
    generate_document,
    generatable_template,
    generate_tax_invoice_request,
    generate_settlement_documents,
    update_application_status,
    send_document_to_docusign,
    send_email_to_customer,
    send_email_to_lender,
    download_as_zip,
    delete_temp_zip,
    generate_brokerage_commission_invoice,
    update_submission_data,
    upload_documents_to_lender,
    upload_hem_living_expense,
    get_hem_living_expense,
    clone_loan_application,
    reset_advance_filter,
    open_comment_dialog,
    fetch_administration_loan_asset_types,
    fetch_administration_app_status_types,
    get_broker_query,
    get_referrer_query,
    get_lender_query,
    get_reporting_meta_data,
    get_pre_graph_data,
    get_email_audit_logs,
    ensure_reporting_meta_data,
    ensure_pre_graph_data,
    get_default_ownership,
    fetch_lender_list,
    fetch_document_type_list,
    toggle_lender_setting,
    toggle_submit_to_lender_form,
    ensure_active_applications_graph_data,
    request_cross_match,
    remove_glass_price,
    export_drive_leads,
    request_documents_via_email,
    request_documents_via_sms,
    fetch_administration_agents,
    get_all_types_agents_query,
    performSearchAddress,
    performSearchNvic,
    selectAddressMethod,
    selectNvicMethod,
    copyFromApplicant1,
    fetch_administration_adjustments,
    submit_bid,
    fetch_highest_bid,
    buy_auction,
    fetch_veda_report,
    request_original_credit_report,
    lock_application,
    check_application_lock,
    release_application_lock,
    fetch_application_locks,
    fetch_referrals,
    load_introducer,
    process_the_auction,
    remove_from_auction,
    move_to_sql,
    get_agent_query,
    fetch_administration_veda_rules,
    submit_for_application_readinessCheck,
    import_hubspot_csv,
    import_suncorp_csv,
    get_sms_audit_logs,
    saveBrokerIncomes,
    updateApplicationNextAction,
    check_agent_subscription,
    update_menu_visibility,
    send_quick_response,
    get_quick_response_content,
    pepper_v3_check_status_submit_to_lender,
    add_audit_log,
    export_approval_pull_through,
    get_call_outcome_logs,
    subscribe_to_pusher_channel,
    get_cut_off_day,
    save_cut_off_day,
    update_auction_notification,
    update_last_auction_notification_timestamp,
    fetch_all_lead_requests,
    fetch_lead_requests_by_pod,
    fetch_lead_requests_by_broker,
    save_lead_request,
    fetch_lead_requests_by_user,
    fetch_user_by_id,
    get_income_triggers,
    save_income_triggers,
    generate_preliminary_documents,
    submit_lead_allocation,
    fetch_live_auction_previews
};
